import { NavigateOptions, useNavigate } from 'react-router';
import { PathKey, PATHS } from './paths';

type AppNavigateOptions = NavigateOptions & { search?: string };

/** Wrapper de `useNavigate` que recebe uma chave de `PATHS` (em vez de uma rota já resolvida), com autocomplete e checagem em tempo de compilação. */
export function useAppNavigate() {
  const navigate = useNavigate();
  return (key: PathKey, { search, ...options }: AppNavigateOptions = {}) => {
    const pathname = `/${PATHS[key]}`;
    navigate(search ? { pathname, search } : pathname, options);
  };
}
